export default __webpack_public_path__ + "static/media/s7.e4ce18d4.jpg";